import Spinner from 'components/Spinner';
import React from 'react';
import Autosuggest from 'react-autosuggest';

import { getLogSuggestions, getLogsModels } from '../../api';

const getSuggestionValue = (suggestion) => suggestion.event_type;

export default class FilterActions extends React.Component {
  constructor(props) {
    super(props);

    this.autoSuggestWrapperRef = React.createRef();
    this.clearFilter = this.clearFilter.bind(this);
    this.filter = this.filter.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onSuggestionsClearRequested =
      this.onSuggestionsClearRequested.bind(this);
    this.onSuggestionsFetchRequested =
      this.onSuggestionsFetchRequested.bind(this);
    this.requestSuggestions = this.requestSuggestions.bind(this);
    this.hideSuggestion = this.hideSuggestion.bind(this);

    this.state = {
      filter: '',
      model: '',
      modelId: '',
      logsModels: [],
      suggestions: [],
      activeFilter: '',
      forceOpenSuggestion: false,
      loading: false,
    };
  }

  clearFilter() {
    const { onSubmit } = this.props;
    this.setState({
      filter: '',
      suggestions: [],
      activeFilter: '',
      model: '',
      modelId: '',
      forceOpenSuggestion: false,
    });
    const page = 1;

    onSubmit({}, page);
  }

  filter(event, { suggestionValue }) {
    const { onSubmit } = this.props;
    const { model, modelId } = this.state;

    this.setState({
      activeFilter: suggestionValue,
      forceOpenSuggestion: false,
    });
    const page = 1;

    onSubmit(
      {
        event: suggestionValue,
        model: model ? model : undefined,
        modelId: modelId ? modelId : undefined,
      },
      page,
    );
  }

  handleClickFilter = () => {
    const { onSubmit } = this.props;
    const { activeFilter, model, modelId } = this.state;
    const page = 1;
    onSubmit(
      {
        event: activeFilter ? activeFilter : undefined,
        model: model ? model : undefined,
        model_id: modelId ? modelId : undefined,
      },
      page,
    );
  };

  handleChangeModel = (e) => {
    this.setState({ model: e.target.value });
  };

  handleChangeModelId = (e) => {
    this.setState({ modelId: e.target.value });
  };

  onChange(_, { newValue }) {
    this.setState({
      filter: newValue,
    });
  }

  onSuggestionsClearRequested() {
    this.setState({
      suggestions: [],
    });
  }

  // should be at least empty to make autosuggest widget work correctly
  async onSuggestionsFetchRequested({ value }) {}

  async requestSuggestions() {
    if (!this.state.filter) {
      return;
    }

    this.setState({ loading: true });
    try {
      const { data } = await getLogSuggestions(this.state.filter);
      const suggestions = (data && data.results) || [];
      this.setState({
        suggestions,
        forceOpenSuggestion: true,
        loading: false,
      });
    } catch (e) {
      this.setState({ loading: false });
    }
  }

  hideSuggestion = (event) => {
    if (!this.autoSuggestWrapperRef.current.contains(event.target)) {
      if (this.state.forceOpenSuggestion) {
        this.setState({ forceOpenSuggestion: false });
      }
    }
  };
  componentDidMount() {
    getLogsModels()
      .then((res) => {
        this.setState({ logsModels: res.data.models });
      })
      .catch((e) => console.log(e));
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.forceOpenSuggestion !== this.state.forceOpenSuggestion) {
      if (this.state.forceOpenSuggestion) {
        document.body.addEventListener('click', this.hideSuggestion);
      } else {
        document.body.removeEventListener('click', this.hideSuggestion);
      }
    }
  }

  componentWillUnmount() {
    document.body.removeEventListener('click', this.hideSuggestion);
  }

  render() {
    const {
      filter,
      logsModels,
      model,
      modelId,
      loading,
      suggestions,
      activeFilter,
      forceOpenSuggestion,
    } = this.state;

    const inputProps = {
      className: 'form-control',
      placeholder: 'Filter By Event Type',
      value: filter,
      onChange: this.onChange,
    };

    return (
      <React.Fragment>
        <div className="d-flex">
          <div
            style={{ flexGrow: 1, marginRight: '15px' }}
            ref={this.autoSuggestWrapperRef}
          >
            <label className="control-label">Event</label>
            <Autosuggest
              suggestions={suggestions}
              onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
              onSuggestionsClearRequested={this.onSuggestionsClearRequested}
              onSuggestionSelected={this.filter}
              getSuggestionValue={getSuggestionValue}
              alwaysRenderSuggestions={forceOpenSuggestion}
              renderSuggestion={(suggestion) => (
                <div key={suggestion.event_type}>{suggestion.event_type}</div>
              )}
              inputProps={inputProps}
            />
            {activeFilter && (
              <p className="mar-t-5" style={{ marginBottom: '0px' }}>
                <b>Active Event Filter:</b> {activeFilter}
              </p>
            )}
          </div>
          <button
            style={{
              height: '34px',
              marginTop: '25px',
              marginLeft: '15px',
              marginRight: '15px',
            }}
            className="btn btn-primary"
            onClick={this.requestSuggestions}
          >
            Search
          </button>
          <button
            style={{ height: '34px', marginTop: '25px', marginLeft: '15px' }}
            className="btn btn-danger"
            onClick={this.clearFilter}
          >
            Clear
          </button>
          <Spinner showLoader={loading || this.props.loading} />
        </div>
        <div
          className="mar-t mar-b"
          style={{ display: 'flex', alignItems: 'flex-end' }}
        >
          <div style={{ width: '50%', marginRight: '15px' }}>
            <label className="control-label">Model</label>
            <select
              className="form-control"
              value={model}
              onChange={this.handleChangeModel}
            >
              {logsModels.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>
          <div
            style={{ width: '50%', marginLeft: '15px', marginRight: '15px' }}
          >
            <label className="control-label">Model Id</label>
            <input
              className="form-control"
              value={modelId}
              onChange={this.handleChangeModelId}
              disabled={!model}
            />
          </div>
          <button
            style={{ marginLeft: '15px', height: '34px' }}
            className="btn btn-primary"
            onClick={this.handleClickFilter}
          >
            Filter
          </button>
        </div>
      </React.Fragment>
    );
  }
}
